import { render } from "./ImageInput.vue?vue&type=template&id=710b79f4"
import script from "./ImageInput.vue?vue&type=script&lang=js"
export * from "./ImageInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/ImageInput.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "710b79f4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('710b79f4', __exports__)) {
    api.reload('710b79f4', __exports__)
  }
  
  module.hot.accept("./ImageInput.vue?vue&type=template&id=710b79f4", () => {
    api.rerender('710b79f4', render)
  })

}


export default __exports__